import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import {of} from 'rxjs';
import {ConfigurationService} from '../../../entry-routes/configuration/configuration.service';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {map, tap} from "rxjs/operators";
import { Url } from '../../models/url';
import Hotjar from '@hotjar/browser';
import {AuthenticationInterceptor} from '../../../entry-routes/authentication/authentication-interceptor';

export const LOADED_EXTERNAL_SCRIPTS: string[] = [];

export enum ScriptType {
  webComponents,
  taskRules
}

export interface LoadScriptStatus {
  script: string;
  loaded: boolean;
  status: string;
  error: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class DynamicScriptLoaderService {

  private renderer2: Renderer2;

  constructor(
    private configurationService: ConfigurationService,
    private httpClient: HttpClient,
    private rendererFactory2: RendererFactory2
  ) {
      this.renderer2 = this.rendererFactory2.createRenderer(null, null);
  }

  private static getUrlPath(fileName: string, scriptType: ScriptType): string {
    switch (scriptType) {
      case ScriptType.taskRules:
        return '/specific/task-rules/' + fileName;
      case ScriptType.webComponents:
        return '/specific/web-components/' + fileName;
    }
  }

  private static getScriptId(fileName: string, scriptType: ScriptType): string {

    switch (scriptType) {
      case ScriptType.taskRules:
        return 'task-rules-' + fileName.substring(0, fileName.lastIndexOf("."));
      case ScriptType.webComponents:
        return 'web-components-' + fileName.substring(0, fileName.lastIndexOf("."));
    }
  }


  loadScript(fileName: string, scriptType: ScriptType): Observable<LoadScriptStatus> {

      const scriptId = DynamicScriptLoaderService.getScriptId(fileName, scriptType);
      console.debug("DynamicScriptLoaderService loadScript scriptId :", scriptId);
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        return of({ script: fileName, loaded: true, status: 'Already Loaded', error: false });
      } else {
        //load script
        const url = this.configurationService.getApplicationConfig().API_BACK_URL + DynamicScriptLoaderService.getUrlPath(fileName, scriptType);
        // if (fileName === 'wkf-spe-rules.js') {
        //   url = "http://localhost:4200/assets/task-rules/wkf-spe-rules.js"
        // }
        // const url = 'http://localhost:4200/assets/mock/web-component/nexia-web-component-indexation.js';
        const script: HTMLScriptElement = document.createElement('script');
        script.type = 'text/javascript';
        // script.src = url;
        script.id = scriptId
        return this.httpClient.get(url, {
          responseType: "text",
          headers: new HttpHeaders().set(AuthenticationInterceptor.BYPASS_HEADER, '')
        }).pipe(
            tap(response => {
              script.text = response;
              document.getElementsByTagName('head')[0].appendChild(script);
            }),
            map(response => {
              console.debug('DynamicScriptLoaderService loadScript response:',response)
              return {script: fileName, loaded: true, status: 'Loaded', error: false}
            })
        );
      }
  }

  loadExternalScript(url: string) {
      if (!LOADED_EXTERNAL_SCRIPTS.includes(url) && typeof document?.head !== 'undefined') {
          const scriptTag = this.renderer2.createElement('script');
          this.renderer2.setProperty(scriptTag, 'src', url);
          this.renderer2.appendChild(document.head, scriptTag);
          LOADED_EXTERNAL_SCRIPTS.push(url);
      }
  }

    loadEternalScriptOfHOTJAR() {
        const hotjarJsClientProjectFileName : string =  this.configurationService.getApplicationConfig()['HOTJAR_JS_CLIENT_PROJECT_FILE_NAME'];
        if(  !!hotjarJsClientProjectFileName && hotjarJsClientProjectFileName.length > 0)
        {
          const jsHotjarUrl = Url.HOTJAR_JS_BASE_URL + hotjarJsClientProjectFileName;
          this.loadExternalScript(jsHotjarUrl);
        }

        // HOTJAR_CLIENT_PROJECT_ID est optionnel, il servira si on veut affiner/ajouter des données à envoyer à hotjar
        // Cf https://help.hotjar.com/hc/fr/articles/36820006944657-Hotjar-sur-les-applications-%C3%A0-page-unique#h_01HE88BJRBP2Y4RN4KRXBM42CN
        //  -> Suivre les changements manuellement
        // et https://hotjar.github.io/hotjar-js/
        const hotjarProjectSiteId : string =  this.configurationService.getApplicationConfig()['HOTJAR_CLIENT_PROJECT_ID'];
        if(!!hotjarProjectSiteId &&  hotjarProjectSiteId.length > 0 ) {
            const hotjarVersion = 6;
            try {
                const ihotjarProjectSiteId = parseInt(hotjarProjectSiteId);
                Hotjar.init(ihotjarProjectSiteId, hotjarVersion);

                // Initializing with `debug` option:
                Hotjar.init(ihotjarProjectSiteId, hotjarVersion, {
                    debug: true
                });
            } catch ( e ) {
                console.error("erreur lors de l'init de hotjar " + e);
            }

        }
    }
}
